import clock from "./clock";
import display from "./display";
import { Handler } from "./handler";
import scoreboard, { Penalty } from "./scoreboard";

export class MainMenu extends Handler {
    constructor() {
        super();
    }

    public override boot(): void {
        display.line1("MENU- MAIN");
        display.line2("NEW GAME?");
    }

    public onEnter(): void {
        scoreboard.reset();
        clock.setMainClockVal(0);
        clock.popHandler();
    }

    public onClear(): void {
        clock.popHandler();
    }
}
